<style lang="stylus">
.profile {
  background-color: #FFC627;
  font-size: 20px;
  border-radius: 8px 8px 0px 0px;
}

.completeProfile {
  border-radius: 23px;
  background-color: #FFC627;
}

.progress-bar {
  border-radius: 5px;
}
</style>

<template>
  <div @click="openCloseModal()" style="cursor: pointer; position: relative">
    <!-- Loading Overlay -->
    <v-overlay v-model="activeLoading" class="align-center justify-center" :persistent="true" contained>
      <v-progress-circular color="primary" indeterminate size="32" width="3" />
    </v-overlay>
    <v-row style="margin: 0 0 0 0" v-if="shouldShowCompletionBox()" class="mt-8 mt-md-0">
      <v-row class="profile" style="padding: 1.15rem">
        <v-col cols="2" class="align-self-center px-2 py-2">
          <v-icon color="black" style="font-size: 42px; font-weight: 300" class="far fa-user-circle my-3 ml-1" />
        </v-col>
        <v-col cols="10" class="align-self-center pl-1">
          <p style="margin: 0" class="font-weight-bold body-4">
            Incomplete profile
            <v-icon
              color="black"
              style="font-size: 16px"
              class="pl-2 mb-1 fas fa-exclamation-triangle"
              @click="asuoDataLayerClick('profileCompletion', '0')"
            />
          </p>
        </v-col>
      </v-row>
      <v-row>
        <div
          class="mb-8"
          style="
            border-left: 1px solid #d0d0d0;
            border-right: 1px solid #d0d0d0;
            border-bottom: 1px solid #d0d0d0;
            border-radius: 0px 0px 8px 8px;
            width: 100%;
            padding: 1.15rem;
          "
        >
          <div>
            <v-col cols="12" style="max-width: 450px">
              <div class="progress">
                <div
                  class="progress-bar progress-bar-warning"
                  role="progressbar"
                  aria-valuenow="70"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  v-bind:style="{ width: totalProgress + '%' }"
                />
              </div>
            </v-col>
            <div class="text-body-1">
              <v-col cols="12">
                <div class="font-weight-bold mt-1" style="font-size: 14px">{{ totalProgress }}% complete</div>
              </v-col>

              <v-col cols="12">
                <svg height="5" width="100%">
                  <line x1="0" y1="0" x2="100%" y2="0" style="stroke: #d0d0d0; stroke-width: 2" />
                </svg>
                <v-row class="mx-0" align="center">
                  <v-icon
                    v-if="basicInfoCurrent !== totalBasicInfo"
                    size="large"
                    class="pl-0 pr-2"
                    style="font-weight: 100"
                    >mdi-circle-outline</v-icon
                  >
                  <v-icon v-else color="#66A11B" style="font-size: 24px; font-weight: 100" class="pl-0 pr-2"
                    >mdi-check-circle</v-icon
                  >
                  <span style="font-size: 14px">Basic information</span>
                  <span class="ml-auto" style="font-size: 14px">{{ basicInfoCurrent }}/{{ totalBasicInfo }}</span>
                </v-row></v-col
              >
              <v-col cols="12" v-if="collectDemographicInfo">
                <svg height="5" width="100%">
                  <line x1="0" y1="0" x2="100%" y2="0" style="stroke: #d0d0d0; stroke-width: 2" />
                </svg>
                <v-row class="mx-0" align="center">
                  <v-icon
                    v-if="demographicInfoCurrent !== totalDemographicInfo"
                    class="pl-0 pr-2"
                    size="large"
                    style="font-weight: 100"
                    >mdi-circle-outline</v-icon
                  >
                  <v-icon v-else color="#66A11B" style="font-size: 24px; font-weight: 100" class="pl-0 pr-2"
                    >mdi-check-circle</v-icon
                  >
                  <span style="font-size: 14px">Demographic information</span>
                  <span class="ml-auto" style="font-size: 14px"
                    >{{ demographicInfoCurrent }}/{{ totalDemographicInfo }}</span
                  >
                </v-row></v-col
              >
            </div>
            <v-col cols="12" class="pt-4" v-if="demographicInfoCurrent !== totalDemographicInfo">
              <Button variant="gold" @click="asuoDataLayerClick('profileCompletion', '1')">
                Complete your profile
              </Button>
            </v-col>
          </div>
        </div>
      </v-row>
    </v-row>

    <profile-completion-modal
      v-if="completeProfile"
      @close="closeDialog($event)"
      @closeModal="openCloseModal($event)"
      :demographicInformation="demographicInfo"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { Logger } from '../mixins/logger';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { DataLayerMixin } from '../mixins/dataLayerMixin';

import ProfileCompletionModal from '../components/ProfileCompletionModal.vue';
import Button from '@/components/ui/Button.vue';

export default defineComponent({
  emits: ['reloadInfo'],
  mixins: [Logger, AjaxLoader, DataLayerMixin],

  components: {
    'profile-completion-modal': ProfileCompletionModal,
    Button
  },

  props: {
    basicLearnerInfo: {
      type: Object
    },
    demographicInfo: {
      type: Object
    },
    totalBasicInfo: {
      type: Number
    },
    basicInfoCurrent: {
      type: Number
    },
    totalDemographicInfo: {
      type: Number
    },
    demographicInfoCurrent: {
      type: Number
    },
    totalProgress: {
      type: Number
    }
  },

  data() {
    return {
      completeProfile: false,
      collectDemographicInfo: this.$conn.learnerData._collectDemographicInfo
    };
  },

  methods: {
    shouldShowCompletionBox() {
      if (this.totalProgress == 100) return false;
      else {
        //since pronoun is optional (making it complete if only pronoun is not selcted)
        if (this.totalProgress == 90 && !this.demographicInfo.pronoun) return false;
        else return true;
      }
    },
    openCloseModal() {
      this.completeProfile = !this.completeProfile;
    },
    async closeDialog(event) {
      this.completeProfile = !event;
      this.$emit('reloadInfo', true);
    }
  }
});
</script>
